import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['select', 'loadButton', 'buttonText']
  static values = { apiBase: String, clientUuid: String }

  connect() {
    this.loaded = false
    if (this.hasSelectTarget) this.selectTarget.style.display = 'none'
    if (this.hasLoadButtonTarget) this.loadButtonTarget.style.display = 'block'
  }

  async load() {
    if (this.loaded) return
    const loadButton = this.hasLoadButtonTarget ? this.loadButtonTarget : this.element.querySelector('[data-fetch-cat-index-target="loadButton"]')
    const select = this.hasSelectTarget ? this.selectTarget : this.element.querySelector('[data-fetch-cat-index-target="select"]')
    const buttonText = this.hasButtonTextTarget ? this.buttonTextTarget : loadButton?.querySelector('[data-fetch-cat-index-target="buttonText"]')
    if (!loadButton || !select) return

    const originalContent = loadButton.innerHTML
    loadButton.disabled = true
    loadButton.style.opacity = '0.7'
    loadButton.style.cursor = 'wait'
    
    if (buttonText) {
      buttonText.innerHTML = '<span class="loading-spinner">⟳</span> Loading...'
    } else {
      loadButton.innerHTML = '<span class="loading-spinner">⟳</span> Loading...'
    }

    try {

        const apiBase = this.apiBaseValue || this.element.dataset.fetchCatIndexApiBaseValue

        let clientUuid = this.clientUuidValue || this.element.dataset.fetchCatIndexClientUuidValue
        console.log('Client UUID:', clientUuid)
        if (!clientUuid) {
          const form = select.closest('form')
          const cidInput = form?.querySelector('input[name="cid"]')
          if (cidInput && cidInput.value) clientUuid = cidInput.value
        }
        if (!clientUuid) throw new Error('Client UUID not found')

        // token: hard-coded (same for all)
        const token = 'bf1a75bd-d479-48a7-a159-4c6abbdfb668'
        const url = `${apiBase}/catalogues/?client_id=${encodeURIComponent(clientUuid)}`
      const headers = token ? { token } : {}
      console.log('Fetching catalogues from:', url)
      console.log('Using headers:', headers)
      const resp = await fetch(url, { headers })
      if (!resp.ok) throw new Error('Network response was not ok')
      const data = await resp.json()
      if (!Array.isArray(data.catalogues)) throw new Error('Invalid response')

      const blank = Array.from(select.options).find(o => o.value === '')
      select.innerHTML = ''
      if (blank) select.appendChild(blank)
      data.catalogues.forEach(c => {
        const opt = document.createElement('option')
        opt.value = c.id
        opt.textContent = c.name
        select.appendChild(opt)
      })
      if (select.dataset.selected) select.value = select.dataset.selected

      loadButton.style.display = 'none'
      select.style.display = 'block'
      this.loaded = true
    } catch (e) {
      console.error(e)
      loadButton.disabled = false
      loadButton.style.opacity = '1'
      loadButton.style.cursor = 'pointer'
      loadButton.innerHTML = originalContent
    }
  }
}
